import React from 'react';
import Image, { ImageLoaderProps } from 'next/image';
import styles from './async-image.module.scss';
import { environment } from '@environment';
import { getCoverArtImage } from '@helpers/operators-helper';

type ImageProps = {
	imgSrc?: string;
	coverArtId?: string;
	width?: number;
	height?: number;
	objectFitStyle?: 'contain' | 'cover';
	imageClass?: string;
	isFullWidth?: boolean;
	layout?: 'responsive' | 'fixed' | 'intrinsic' | 'fill';
	alt?: string;
	isPriority?: boolean;
	sizes?: string;
	style?: React.CSSProperties;
	className?: string;
	hasNoDefaultStyles?: boolean;
};

export const imageLoader = ({ src }: ImageLoaderProps) => {
	if (src.startsWith('http')) {
		return src;
	}

	return `${environment.web_cdn_url}web/assets/img/${src}`;
};

const AsyncImage = ({
	imgSrc,
	coverArtId,
	width,
	height,
	imageClass,
	isFullWidth,
	layout,
	alt,
	objectFitStyle,
	isPriority = false,
	sizes,
	style,
	className,
	hasNoDefaultStyles = false
}: ImageProps) => {
	return (
		<Image
			priority={isPriority}
			className={`${hasNoDefaultStyles ? '' : styles.async_image} ${styles[imageClass]} ${
				className || ''
			}`}
			loader={imageLoader}
			src={imgSrc || getCoverArtImage(coverArtId)}
			alt={alt || ''}
			width={width}
			height={height || width}
			layout={layout || (isFullWidth ? 'responsive' : 'fixed')}
			objectFit={objectFitStyle || 'contain'}
			loading={isPriority ? 'eager' : 'lazy'}
			sizes={sizes}
			style={style}
		/>
	);
};

export default AsyncImage;
